export default "__VITE_ASSET__nXCqVHqI__";